import {
  Component, HostListener, OnInit, TemplateRef, ViewChild,
  ChangeDetectorRef,
  ElementRef,
  NgZone,
  AfterViewInit,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoaderService } from '../loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { whitespace } from '../common/whitespace';
import { GridComponent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { GroupDescriptor, orderBy, SortDescriptor, State } from '@progress/kendo-data-query';
import { ClientDirectoryService } from './client-directory.service'
import { Maps, MapService } from '../service/map.service';
import { nameValidator } from '../common/name-validator';
import { ApiService } from '../service/api.service';
import { GridSettingsService } from '../service/grid-settings.service';


const colors = [
  "red",
  "blue",
  "green",
  "yellow",
  "brown",
  "BurlyWood",
  "Cyan",
  "DarkGreen",
  "DarkOrchid",
  "DarkOliveGreen",
  "Fuchsia",
  "GoldenRod",
  "Indigo",
  "LightCoral",
  "MediumSlateBlue",
];
let colorIndex = 0;

type Components = google.maps.places.PlaceResult['address_components'];

type Entry = {
  place: google.maps.places.PlaceResult;
  marker: google.maps.Marker;
  color: string;
  location: {
    name: string | null | undefined;
    cityName: string | null | undefined;
    countryName: string | null | undefined;
    countryCode: string | null | undefined;
    stateCode: string | null | undefined;
    bounds: google.maps.LatLngBoundsLiteral;
    coordinates: {
      lat: number;
      lng: number;
    };
  } | null;
};

@Component({
  selector: 'app-client-directory',
  templateUrl: './client-directory.component.html',
  styleUrls: ['./client-directory.component.css'],
  providers: [MapService],
})


export class ClientDirectoryComponent implements OnInit, AfterViewInit {
  @ViewChild("grid", { static: true }) gridKendo: GridComponent;
  @ViewChild("search")
  public searchElementRef: ElementRef;
  @ViewChild("searchAdd")
  public searchAddElementRef: ElementRef;

  @ViewChild("map")
  public mapElementRef: ElementRef;

  @ViewChild("clientDirectoryDialog") clientDirectoryDialog: TemplateRef<any>;
  @ViewChild("updateStatusDialog") updateStatusDialog: TemplateRef<any>;
  @ViewChild("domainConvertDialog") domainConvertDialog: TemplateRef<any>;
  @ViewChild("Myfile", { static: true }) Myfile: ElementRef;
  matdialogRef: MatDialogRef<any>;
  matdialogTimmingRef: MatDialogRef<any>;
  matdialogSpecializationRef: MatDialogRef<any>;
  public groups: GroupDescriptor[] = [];
  public sort: SortDescriptor[] = [];
  public gridHeight: number;
  columnList: any = [];
  addClientDirectoryFrom!: FormGroup;
  timingForm!: FormGroup;
  editTypeId: any;
  action: any;
  kendoLoading = false;
  gridData: GridDataResult;
  clientDirectoryData: any;
  searchString: any = '';
  public state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: "and",
      filters: [],
    },
    group: this.groups,
  };
  servicesList: any[] = [];
  servicesForm: FormGroup;
  selectedServices: { Id: number; Name: string }[] = [];
  filteredServicesList: any[] = [];
  specializationList: any[] = [];
  specializationForm: FormGroup;
  selectedSpecialization: { Id: number; Name: string }[] = [];
  filteredSpecializationList: any[] = [];
  public formGroup: FormGroup;
  status: boolean = false;
  selectedDoctor: any = [];
  isClientDomain = false;
  weekDays: string[] = [
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
  ];
  profileUrl: any;
  profileName: any;
  fileList: FileList;
  doctorTimings: any[] = [];
  public place: google.maps.places.PlaceResult;
  private readonly map: google.maps.Map;
  entries: Entry[] = [];
  cityName: any;
  stateName: any;
  countryName: any;
  showTimingError = false;
  fileInputVisible = true;
  emailerror: boolean = false;
  originalEmail: any;
  total: 0;
  public pageableWithAll: any = {
    pageSizes: [5, 10, 20, 50, 100, 'All']
  };
  domainForm!: FormGroup;
  domain = window.location.host;
  domainName: string = '';
  error: boolean = false;
  companycodeerror: boolean = false;
  plusDoctor: boolean;
  hide: boolean = true;
  currencyList: any = [];
  loading: boolean = false;
  isInProgress: boolean = false;
  ipAddress: any;
  ipLocation: any;
  isMaximized = false;
  originalOverlayStyle: Partial<CSSStyleDeclaration> = {};
  originalDialogStyle: Partial<CSSStyleDeclaration> = {};
  TableName = "ClientDirectory";
  constructor(
    private readonly dialog: MatDialog,
    private readonly formBuilder: FormBuilder,
    private readonly loaderService: LoaderService,
    private readonly toaster: ToastrService,
    private readonly clientDirectoryService: ClientDirectoryService,
    private readonly cd: ChangeDetectorRef,
    private readonly mapService: MapService,
    private readonly ngZone: NgZone,
    private readonly _http: ApiService,
    private readonly gridSettings: GridSettingsService) { }

  ngOnInit(): void {
    this.loadClientDirectoryData();
    this.setGridHeight();
    this.LoadForm();
    this.BindTimingForm();
    this.getServicesList();
    this.getSpecializationList();
    this.LoadDomainInit()
    this.GetIPLocation();

    this.filteredSpecializationList = this.specializationList.slice();
    this.updateLabelState_special();

    this.filteredServicesList = this.specializationList.slice();
    this.updateLabelState_service();
  }

  GetIPLocation() {
    if (!localStorage.getItem("IA")) {
      this._http.getIPAddress().subscribe((x: any) => {
        const ipAddress = x.ip;
        this.ipAddress = ipAddress;
        localStorage.setItem("IA", this.ipAddress);
      });
    } else {
      this.ipAddress = localStorage.getItem("IA");
    }

    this._http.getIPLocation().subscribe((data: any) => {
      this.ipLocation = `${data?.city}`;
    });
  }

  LoadForm() {
    this.addClientDirectoryFrom = this.formBuilder.group({
      Id: [0],
      Name: ['', [Validators.required, whitespace, nameValidator]],
      ClinicName: ['', [Validators.required, whitespace]],
      Email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$'),
          whitespace,
        ],
      ],
      Address: ['', [Validators.required, whitespace]],
      State: ['', [Validators.required, whitespace]],
      MobileNumber: ['', [this.mobileNumberValidator]],
      Education: ['', [Validators.required, whitespace]],
      Experience: ['', [Validators.required, Validators.min(0)]],
      Memberships: new FormControl(""),
      ConsultationFees: ['', [Validators.required, Validators.min(0)]],
      Description: new FormControl(""),
      ServicesIds: [[], [Validators.required]],
      SpecializationIds: [[], [Validators.required]],
      Gender: ['Male', Validators.required],
      Salutation: ['Dr.']
    });

    this.domainForm = new FormGroup({
      FirstName: new FormControl(""),
      Salutation: new FormControl(""),
      CompanyName: new FormControl(""),
      CompanyCode: new FormControl(""),
      Email: new FormControl(""),
      PhoneNumber: new FormControl(""),
      Password: new FormControl(""),
      CompanyAddress: new FormControl(""),
      CurrencyId: new FormControl("")
    });
  }

  BindTimingForm() {
    if (!this.timingForm) {
      this.timingForm = this.formBuilder.group({
        ClinicTimings: this.formBuilder.array([])
      });
    }

    const timingArray = this.timingForm.get('ClinicTimings') as FormArray;
    timingArray.clear();

    if (this.doctorTimings && this.doctorTimings.length > 0) {
      this.doctorTimings.forEach(t => {
        this.timingArray.push(this.newTimingGroup(
          t.FromDay,
          t.ToDay,
          t.FromTime,
          t.ToTime,
          false
        ));
      });
    } else {
      this.timingArray.push(this.newTimingGroup('Monday', 'Friday', null, null, true));
    }
  }

  setDefaultFormValues() {
    if (!this.addClientDirectoryFrom) {
      this.LoadForm();
    }
    this.addClientDirectoryFrom.reset({
      Salutation: 'Dr.',
      Name: '',
      ClinicName: '',
      Email: '',
      Address: '',
      Mobile: '',
      Experience: '',
      Education: '',
      Memberships: '',
      ConsultationFees: '',
      State: '',
      Description: '',
      Gender: 'Male',
    });
    this.doctorTimings = [];
    this.selectedServices = [];
    this.selectedSpecialization = [];
    this.addClientDirectoryFrom.get('ServicesIds')?.setValue([]);
    this.addClientDirectoryFrom.get('SpecializationIds')?.setValue([]);
    this.cityName = '';
    this.countryName = '';
    this.stateName = '';
    this.profileUrl = '';
    this.profileName = '';
    this.showTimingError = false;
    if (this.timingForm) {
      this.timingForm.reset();
    }
  }

  loadClientDirectoryData() {
    this.loaderService.show();
    this.total = 0;
    this.clientDirectoryService.getClientDirectory(this.state, JSON.stringify(this.searchString)).subscribe({
      next: (res: any) => {
        if (res["Success"] && res["Data"]) {
          this.clientDirectoryData = res["Data"].map((item: any) => ({
            ...item,
            ClinicTimeDisplay: this.formatClinicTimings(item.ClinicTimings)
          }));
          this.total = res["Total"];
          this.columnList.push(
            "Name",
            "ClinicName",
            "Email",
            "Address",
            "Mobile",
            "Experience",
            "Education",
            "Memberships",
            "ConsultationFees",
            "City",
            "State",
            "IsDoctorDirectoryEnable",
            "IsClientDomain",
            "Gender",
            "ServicesDisplay", "SpecializationDisplay", "ClinicTimeDisplay"
          );
          this.gridData = {
            data: orderBy(this.clientDirectoryData, this.sort),
            total: this.total,
          };
        } else {
          this.gridData = {
            data: [],
            total: 0
          };
          this.total = 0;
        }
        this.loaderService.hide();
      },
      error: (_err) => {
        this.loaderService.hide();
        this.toaster.error('Something went wrong Record not Updated sorry');
      }
    });
  }


  public dataStateChange(state: any): void {
    this.state = state;
    this.loadClientDirectoryData(); // 🔑 single place for API
  }

  // Remove API calls from these, just update state if needed
  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip ?? 0;
    this.state.take = event.take ?? this.state.take ?? 20;
  }

  public sortChange(sort: SortDescriptor[]): void {
    // custom sort toggle (optional)
    if (this.sort[0]?.dir === "asc") {
      sort[0].dir = "desc";
    }
    this.sort = sort;
  }

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
  }

  public clearList(): void {
    if (!this.searchString) return;
    this.state.skip = 0;
    this.searchString = "";
    this.loadClientDirectoryData(); // ✅ manual reset
  }

  public filterData(event: string): void {
    const lastValue = this.searchString;
    this.searchString = event;
    if (this.searchString || lastValue) {
      this.state.skip = 0;
      this.loadClientDirectoryData(); // ✅ manual search
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setGridHeight();
  }

  setGridHeight(): void {
    const headerHeight = 70; // Adjust according to your header and other elements
    const footerHeight = 61;
    const otherElementsHeight = 125;
    this.gridHeight = window.innerHeight - headerHeight - footerHeight - otherElementsHeight;
  }

  formatClinicTimings(timings: any[]): string {
    if (!timings || timings.length === 0) return '';
    return timings.map(t => {
      const fromTime = this.formatTimeWithAmPm(t.FromTime);// take HH:MM only
      const toTime = this.formatTimeWithAmPm(t.ToTime);  // take HH:MM only
      return `${t.FromDay}-${t.ToDay} ${fromTime}-${toTime}`;
    }).join(',<br>');
  }

  formatTimeWithAmPm(time24: string): string {
    const [hourStr, minute] = time24.split(':');
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12; // convert 0 -> 12 for midnight
    return `${hour}:${minute} ${ampm}`;
  }

  getServiceNameById(id: number): string {
    const service = this.servicesList.find(s => s.Id === id);
    return service ? service.Name : '';
  }

  closeDialog() {
    this.dialog?.closeAll();
  }

  openClientDirectoryDialog(data: any) {

    this.resetFile();
    if (data) {
      if (data.Gender === 1) {
        data.Gender = "Male";
      } else if (data.Gender === 2) {
        data.Gender = "Female";
      }
      this.addClientDirectoryFrom.patchValue(data);
      this.patchSelectedServices(data.SelectedServices ?? []);
      this.patchSelectedSpecialization(data.SelectedSpecialization ?? []);
      this.editTypeId = data.Id;
      this.action = "Update";
      this.isClientDomain = data.IsClientDomain;
      data.IsClientDomain ? this.disabledFiled() : this.enableField();
      this.doctorTimings = (data.ClinicTimings ?? []).map((t: any) => ({
        ...t,
        FromTime: this.convertToDate(t.FromTime),
        ToTime: this.convertToDate(t.ToTime)
      }));
      this.addClinicTimmingForm(data.ClinicTimings);
      if (data.ProfileImg) {
        let str = "data:image/png;base64,";
        this.profileUrl = `${str}${data.ProfileImg}`;
        this.profileName = data.ProfileImgName;
        this.loadExistingFile(data.ProfileImg, data.ProfileImgName);
      } else {
        this.profileUrl = "";
        this.profileName = "";
      }
      this.cityName = data.City;
      this.countryName = data.Country;
      this.originalEmail = data.Email;
    } else {
      this.action = "Add";
      this.editTypeId = 0;
      this.setDefaultFormValues();
      this.enableField();
    }

    const dialogRef = this.dialog?.open(this.clientDirectoryDialog, {
      width: '60vw',
      autoFocus: false,
      disableClose: true
    });

    dialogRef?.afterOpened().subscribe(() => {
      this.mapService.load().then((maps) => {
        this.initAutocomplete(maps);
      });
    });

    dialogRef?.afterClosed().subscribe(() => {
      this.setDefaultFormValues();
    });
  }

  enableField() {
    this.addClientDirectoryFrom.get('Name')?.enable();
    this.addClientDirectoryFrom.get('ClinicName')?.enable();
    this.addClientDirectoryFrom.get('Email')?.enable();
    this.addClientDirectoryFrom.get('MobileNumber')?.enable();
  }

  disabledFiled() {
    this.addClientDirectoryFrom.get('Name')?.disable();
    this.addClientDirectoryFrom.get('ClinicName')?.disable();
    this.addClientDirectoryFrom.get('Email')?.disable();
    this.addClientDirectoryFrom.get('MobileNumber')?.disable();
  }

  patchSelectedServices(selectedServicesData: any[]) {
    if (!selectedServicesData?.length) {
      this.selectedServices = [];
      this.addClientDirectoryFrom.get('ServicesIds')?.setValue([]);
      return;
    }

    // Extract IDs based on structure
    const selectedServiceIds = selectedServicesData[0]?.CompanyServiceId !== undefined
      ? selectedServicesData.map(s => s.CompanyServiceId)
      : selectedServicesData;

    // Match with master services list to show names & checkboxes
    this.selectedServices = this.servicesList.filter(s => selectedServiceIds.includes(s.Id));

    // Patch form control with array of selected service IDs
    this.addClientDirectoryFrom.get('ServicesIds')?.setValue(selectedServiceIds);
  }

  private formatTime(date: Date): string {
    if (!date) return '';
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(date.getHours())}:${pad(date.getMinutes())}:00.000`;
  }

  submitClientDirectory() {
    if ((!this.addClientDirectoryFrom.valid || this.emailerror)) {
      this.addClientDirectoryFrom.markAllAsTouched();
      return;
    }

    const clinicTimings = this.doctorTimings
      .filter((t: any) => t.FromTime && t.ToTime);

    const payload = {
      ...this.addClientDirectoryFrom.value,
      Id: this.editTypeId ?? 0,
      IsClientDomain: this.isClientDomain,
      Gender: this.addClientDirectoryFrom.value.Gender == "Male" ? 1 : 2,
      ClinicTimings: clinicTimings
        .filter((t: any) => t.FromTime && t.ToTime).map((t: any) => ({
          ...t,
          FromTime: this.formatTime(t.FromTime),
          ToTime: this.formatTime(t.ToTime)
        })),
      City: this.cityName,
      Country: this.countryName,
      IPAddress: this.ipAddress,
      IPLocation: this.ipLocation
    };

    if (this.editTypeId && this.editTypeId !== 0) {
      this.updateClientDirectory(payload)
    } else {
      this.addNewClientDirectory(payload)
    }
  }

  ValidateClinicTimmings() {
    const clinicTimingsArray = this.timingForm.get('ClinicTimings') as FormArray;
    if (!clinicTimingsArray || clinicTimingsArray.length === 0) {
      this.showTimingError = true;
      return false;
    }

    const hasValidRow = clinicTimingsArray.controls.some(group => {
      const fromTime = group.get('fromTime')?.value;
      const toTime = group.get('toTime')?.value;
      return fromTime && toTime;
    });

    this.showTimingError = !hasValidRow;
    return hasValidRow;
  }

  addNewClientDirectory(payload: any) {
    const formData = new FormData();
    if (this.fileList && this.fileList.length > 0) {
      formData.append("File", this.fileList[0]);
    }
    // attach payload as JSON string
    formData.append("Data", JSON.stringify(payload));
    this.clientDirectoryService.CreateClientDirectory(formData).subscribe({
      next: (res: any) => {
        if (res["Success"]) {
          this.toaster.success('Client Directory added Successfully');
          this.loadClientDirectoryData();
          this.loaderService.hide();
          this.closeDialog();
        } else {
          this.toaster.error('Something went wrong Record not Updated sorry');
          this.loaderService.hide();
        }
      },
      error: (_err) => {
        this.toaster.error('Something went wrong Record not Updated sorry');
        this.loaderService.hide();
      }
    });
  }

  updateClientDirectory(payload: any) {
    const formData = new FormData();
    if (this.fileList && this.fileList.length > 0) {
      formData.append("File", this.fileList[0]);
    }
    // attach payload as JSON string
    formData.append("Data", JSON.stringify(payload));

    this.loaderService.show();
    this.clientDirectoryService.updateClientDirectory(formData).subscribe({
      next: (res: any) => {
        if (res["Success"]) {
          this.toaster.success('Client Directory Updated Successfully');
          this.loadClientDirectoryData();
          this.closeDialog();
          this.loaderService.hide();
        } else {
          this.toaster.error('Something went wrong Record not Updated sorry');
          this.loaderService.hide();
        }
      },
      error: (_err) => {
        this.toaster.error('Something went wrong Record not Updated sorry');
        this.loaderService.hide();
      }
    });
  }

  onRowDoubleClick(event: any): void {
    const cell = (event.target as HTMLElement).closest('kendo-grid-list tr');
    if (!cell) return;

    const index = Array.from(cell.parentElement!.children).indexOf(cell);
    const dataItem = this.gridData.data[index];

    if (dataItem) {
      this.openClientDirectoryDialog(dataItem);
    }
  }

  addServices(form: any) {
    if (!form.valid) {
      form.markAllAsTouched();
      return;
    }

    this.loaderService.show();
    this.clientDirectoryService.CreateService(form.value).subscribe({
      next: (res: any) => {
        this.loaderService.hide();

        if (res?.Success) {
          this.toaster.success('Service added Successfully');
          this.matdialogRef.close();
          this.getServicesList().then(() => {
            const newServiceId = res?.Data?.Id;
            const existingSelectedIds =
              this.addClientDirectoryFrom.get('ServicesIds')?.value ?? [];
            const updatedSelectedIds = [...existingSelectedIds, newServiceId];

            this.addClientDirectoryFrom.get('ServicesIds')?.setValue(updatedSelectedIds);

            const newService = this.servicesList.find(s => s.Id === newServiceId);
            if (newService) {
              this.selectedServices = [...this.selectedServices, newService];
            }
          });
        } else if (res.ResponseCode == 439) {
          this.toaster.error('Service already exist');
        } else {
          this.toaster.error('Something went wrong. Record not updated.');
        }
      },
      error: () => {
        this.toaster.error('Something went wrong. Record not updated.');
        this.loaderService.hide();
      }
    });
  }

  async getServicesList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.clientDirectoryService.getServicesAllData().subscribe({
        next: (res: any) => {
          if (res?.Success && res?.Data) {
            this.servicesList = res.Data;
            this.filteredServicesList = [...this.servicesList];
            this.cd.detectChanges();
          }
          resolve();
        },
        error: (err) => reject(err instanceof Error ? err : new Error(String(err)))
      });
    });
  }

  openDialogForAddService(templateRef: TemplateRef<any>) {
    this.servicesForm = this.formBuilder.group({
      Name: new FormControl('', [Validators.required]),
      Id: new FormControl(0),
    });
    this.matdialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      autoFocus: false,
    });
  }

  closeServiceDialog() {
    this.matdialogRef.close();
  }

  toggleService(service: { Id: number; Name: string }, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      if (!this.selectedServices.find(s => s.Id === service.Id)) {
        this.selectedServices.push(service);
      }
    } else {
      this.selectedServices = this.selectedServices.filter(s => s.Id !== service.Id);
    }
    const serviceIds = this.selectedServices.map(s => s.Id);
    this.addClientDirectoryFrom.get('ServicesIds')?.setValue(serviceIds);
    this.updateLabelState_service();
  }

  isSelected(service: { Id: number; Name: string }): boolean {
    return this.selectedServices.some(s => s.Id === service.Id);
  }

  get selectedServicesNames(): string {
    return this.selectedServices.length
      ? this.selectedServices.map(s => s.Name).join(', ')
      : '';
  }

  filterServices(event: any) {
    const searchValue = event?.target?.value?.toLowerCase();
    if (!searchValue || searchValue.trim() === "") {
      this.filteredServicesList = [...this.servicesList];
      return;
    }

    this.filteredServicesList = this.servicesList.filter((service: any) =>
      (service?.Name ?? "").toLowerCase().includes(searchValue)
    );
  }

  // Add Specialization

  openDialogForAddSpecialization(templateRef: TemplateRef<any>) {
    this.specializationForm = this.formBuilder.group({
      Name: new FormControl('', [Validators.required]),
      Id: new FormControl(0),
    });
    this.matdialogSpecializationRef = this.dialog.open(templateRef, {
      disableClose: true,
      autoFocus: false,
    });
  }

  closeSpecializationDialog() {
    this.matdialogSpecializationRef.close();
  }

  async getSpecializationList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.clientDirectoryService.getSpecializationAllData().subscribe({
        next: (res: any) => {
          if (res?.Success && res?.Data) {
            this.specializationList = res.Data;
            this.filteredSpecializationList = [...this.specializationList];
            this.cd.detectChanges();
          }
          resolve();
        },
        error: (err) => reject(err instanceof Error ? err : new Error(String(err)))
      });
    });
  }

  addSpecialization(form: any) {
    if (!form.valid) {
      form.markAllAsTouched();
      return;
    }

    this.loaderService.show();
    this.clientDirectoryService.CreateSpecialization(form.value).subscribe({
      next: (res: any) => {
        this.loaderService.hide();
        if (res?.Success) {
          this.toaster.success('Specialization added Successfully');
          this.getSpecializationList().then(() => {
            const newSpecialId = res?.Data?.Id;
            const existingSelectedIds =
              this.addClientDirectoryFrom.get('SpecializationIds')?.value ?? [];
            const updatedSelectedIds = [...existingSelectedIds, newSpecialId];

            this.addClientDirectoryFrom.get('SpecializationIds')?.setValue(updatedSelectedIds);

            const newSpecialization = this.specializationList.find(s => s.Id === newSpecialId);
            if (newSpecialization) {
              this.selectedSpecialization = [...this.selectedSpecialization, newSpecialization];
            }
          });
          this.matdialogSpecializationRef.close();
        } else if (res.ResponseCode == 439) {
          this.toaster.error('Specialization already exist');
        } else {
          this.toaster.error('Something went wrong. Record not updated.');
        }
      },
      error: () => {
        this.toaster.error('Something went wrong. Record not updated.');
        this.loaderService.hide();
      }
    });
  }

  toggleSpecialization(specialization: { Id: number; Name: string }, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      if (!this.selectedSpecialization.find(s => s.Id === specialization.Id)) {
        this.selectedSpecialization.push(specialization);
      }
    } else {
      this.selectedSpecialization = this.selectedSpecialization.filter(s => s.Id !== specialization.Id);
    }
    const specializationIds = this.selectedSpecialization.map(s => s.Id);
    this.addClientDirectoryFrom.get('SpecializationIds')?.setValue(specializationIds);
    this.updateLabelState_special();
  }

  isSelectedSpecialization(specialization: { Id: number; Name: string }): boolean {
    return this.selectedSpecialization.some(s => s.Id === specialization.Id);
  }

  get selectedSpecializationNames(): string {
    return this.selectedSpecialization.length
      ? this.selectedSpecialization.map(s => s.Name).join(', ')
      : '';
  }

  getSpecializationNameById(id: number): string {
    const specialization = this.specializationList.find(s => s.Id === id);
    return specialization ? specialization.Name : '';
  }

  patchSelectedSpecialization(selectedSpecializationData: any[]) {
    if (!selectedSpecializationData?.length) {
      this.selectedSpecialization = [];
      this.addClientDirectoryFrom.get('SpecializationIds')?.setValue([]);
      return;
    }

    // Extract IDs based on structure
    const selectedSpecialIds = selectedSpecializationData[0]?.SpecializationId !== undefined
      ? selectedSpecializationData.map(s => s.SpecializationId)
      : selectedSpecializationData;

    // Match with master services list to show names & checkboxes
    this.selectedSpecialization = this.specializationList.filter(s => selectedSpecialIds.includes(s.Id));

    // Patch form control with array of selected service IDs
    this.addClientDirectoryFrom.get('SpecializationIds')?.setValue(selectedSpecialIds);
  }

  filterSpecializations(event: any) {
    const searchValue = event?.target?.value?.toLowerCase();
    if (!searchValue || searchValue.trim() === "") {
      this.filteredSpecializationList = [...this.specializationList];
      return;
    }

    this.filteredSpecializationList = this.specializationList.filter((special: any) =>
      (special?.Name ?? "").toLowerCase().includes(searchValue)
    );
  }
  // END Specialization

  keyPress(event: any) {
    const pattern = /[0-9+\- ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public onToggleStatus(dataItem: any): void {
    this.status = dataItem.IsDoctorDirectoryEnable;
    this.selectedDoctor = dataItem;
    this.dialog.open(this.updateStatusDialog, {
      autoFocus: false,
      width: '20vw',
      disableClose: true
    })
  }

  updateStatus(): void {
    this.dialog.closeAll();
    this.loaderService.show();
    this.clientDirectoryService.UpdateDirectoryStatus(this.selectedDoctor.Id, this.status).subscribe({
      next: (res: any) => {
        if (res["Success"]) {
          this.toaster.success('Status Updated Successfully');
          this.loadClientDirectoryData();
          this.closeDialog();
          this.loaderService.hide();
        } else {
          this.toaster.error('Something went wrong Record not Updated sorry');
          this.loaderService.hide();
        }
      },
      error: (_err) => {
        this.toaster.error('Something went wrong Record not Updated sorry');
        this.loaderService.hide();
      }
    });
  }

  Noupdate() {
    const index = this.clientDirectoryData.findIndex((u: any) => u.Id === this.selectedDoctor.Id); // or unique key
    if (index !== -1) {
      this.clientDirectoryData[index].IsDoctorDirectoryEnable = !this.status;
    }
  }
  get timingArray(): FormArray {
    return this.timingForm.get('ClinicTimings') as FormArray;
  }

  newTimingGroup(fromDay: string = '', toDay: string = '', fromTime: Date | null = null, toTime: Date | null = null, isNew = true): FormGroup {
    return this.formBuilder.group({
      fromDay: [fromDay],
      toDay: [toDay],
      fromTime: [fromTime],
      toTime: [toTime],
      isNew: [isNew]
    });
  }

  addTimingRow() {
    this.timingArray.push(this.newTimingGroup('Monday', 'Friday', null, null, true));
  }

  onAddClick(index: number) {
    const currentGroup = this.timingArray.at(index) as FormGroup;
    if (currentGroup.valid) {
      this.addTimingRow();
    } else {
      currentGroup.markAllAsTouched();
    }
  }

  openDialogForAddTiming(templateRef: TemplateRef<any>) {
    this.BindTimingForm();

    this.matdialogTimmingRef = this.dialog.open(templateRef, {
      disableClose: true,
      autoFocus: false,
      width: '40vw'
    });
  }

  saveTimingDialog() {
    const values = this.timingForm.get('ClinicTimings')?.value;
    this.doctorTimings = values.map((t: any) => ({
      FromDay: t.fromDay,
      ToDay: t.toDay,
      FromTime: t.fromTime,
      ToTime: t.toTime
    }));
    this.showTimingError = false;
    this.matdialogTimmingRef.close();
  }

  removeTimingRow(index: number) {
    if (this.timingArray.length > 1) {
      this.timingArray.removeAt(index);
    } else {
      const clinicTimings = this.timingForm.get('ClinicTimings') as FormArray;
      clinicTimings.clear();
      this.timingArray.push(this.newTimingGroup('Monday', 'Friday', null, null, true));
    }
  }

  addClinicTimmingForm(ClinicTimings: any[]) {
    (this.timingForm.get('ClinicTimings') as FormArray).clear();

    const clinicTimings = this.timingForm.get('ClinicTimings') as FormArray;
    clinicTimings.clear();

    ClinicTimings.forEach(t => {
      const fromDate = t.FromTime ? new Date(`1970-01-01T${t.FromTime}`) : null;
      const toDate = t.ToTime ? new Date(`1970-01-01T${t.ToTime}`) : null;

      clinicTimings.push(this.newTimingGroup(
        t.FromDay,
        t.ToDay,
        fromDate,
        toDate,
        false
      ));
    });
  }

  onTimeChange(i: number) {
    const timingGroup = this.timingArray.at(i);

    const fromTime = timingGroup.get('fromTime')?.value;
    const toTime = timingGroup.get('toTime')?.value;

    if (fromTime && toTime) {
      const fromMinutes = fromTime.getHours() * 60 + fromTime.getMinutes();
      const toMinutes = toTime.getHours() * 60 + toTime.getMinutes();

      if (fromMinutes >= toMinutes) {
        timingGroup.setErrors({ invalidTime: true });
      } else {
        timingGroup.setErrors(null);
      }
    }

  }

  cancelTimingDialog() {
    this.matdialogTimmingRef.close();
  }

  async onFileChange(e: any) {
    const input = e.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];
    if (!this.validateFile(file)) {
      input.value = '';
      this.resetFile();
      return;
    }

    this.fileList = e.target.files;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event: any) => {
      this.profileUrl = event.target.result;
    };
  }

  validateFile(file: any) {
    const size = 1048576;
    if (file) {
      const extension = file.name.split(".").pop().toUpperCase();
      if (!["PNG", "JPG", "JPEG"].includes(extension)) {
        this.toaster.error("Invalid file! Only PNG, JPG and JPEG files are allowed", "Error");
        return false;
      } else if (file.size > size) {
        this.toaster.error("Upload file with max size of 1MB only", "Error");
        return false;
      }
      return true;
    } else {
      return false;
    }
  }

  resetFile() {

    this.fileList = null as any;
    this.profileUrl = null;
    this.profileName = null;
    this.fileInputVisible = false;
    setTimeout(() => {
      this.fileInputVisible = true;
    }, 0);
  }

  removeImage() {
    this.fileList = null as any;
    this.profileUrl = null;
    this.profileName = null;

    // clear the actual file input
    const fileInput = document.querySelector<HTMLInputElement>('input[type="file"]');
    if (fileInput) {
      fileInput.value = '';
    }
  }

  loadExistingFile(base64: string, filename: string) {
    // Convert base64 -> blob
    if (!base64 || !filename) return;

    const byteString = atob(base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([intArray], { type: "image/png" });

    // Create File
    const file = new File([blob], filename, { type: "image/png" });

    // Build FileList using DataTransfer
    const dt = new DataTransfer();
    dt.items.add(file);
    this.fileList = dt.files; // now behaves like a file input
  }

  initAutocomplete(maps: Maps) {
    let autocomplete = new maps.places.Autocomplete(
      this.searchElementRef.nativeElement
    );
    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        this.onPlaceChange(autocomplete.getPlace());
        this.addClientDirectoryFrom.controls['Address'].setValue(autocomplete.getPlace().formatted_address);
      });
    });
  }

  initDomainAutocomplete(maps: Maps) {
    let autocomplete1 = new maps.places.Autocomplete(
      this.searchAddElementRef.nativeElement
    );
    autocomplete1.addListener("place_changed", () => {
      this.ngZone.run(() => {
        this.onPlaceChange(autocomplete1.getPlace());
        this.domainForm.controls['CompanyAddress'].setValue(autocomplete1.getPlace().formatted_address);
      });
    });
  }

  onPlaceChange(place: google.maps.places.PlaceResult) {
    if (!place.geometry?.location || !place.formatted_address) {
      console.warn('Place is missing geometry or formatted address');
      return;
    }
    const color = colors[colorIndex++ % colors.length];

    const marker = new google.maps.Marker({
      position: place.geometry.location,
      animation: google.maps.Animation.DROP,
      map: this.map,
      icon: this.pin(color),
    });

    const location = this.locationFromPlace(place);
    this.addClientDirectoryFrom.get('Address')?.setValue(place.formatted_address);
    this.domainForm.get('CompanyAddress')?.setValue(place.formatted_address);

    this.entries.unshift({
      place,
      marker,
      color,
      location,
    });
  }

  public locationFromPlace(place: google.maps.places.PlaceResult) {
    const components = place.address_components;
    if (components === undefined) {
      return null;
    }

    const areaLevel3 = this.getShort(components, "administrative_area_level_3");
    const locality = this.getLong(components, "locality");
    const cityName = locality ?? areaLevel3;
    this.cityName = cityName;
    const countryName = this.getLong(components, "country");
    const countryCode = this.getShort(components, "country");
    const stateCode = this.getShort(components, "administrative_area_level_1");
    const stateName = this.getLong(components, "administrative_area_level_1");
    this.addClientDirectoryFrom.get('State')?.setValue(stateName);
    this.addClientDirectoryFrom.get('Country')?.setValue(countryName);
    const name = place.name !== cityName ? place.name : null;
    this.countryName = countryName;
    this.stateName = stateName;

    const lat = place.geometry?.location?.lat() ?? 0;
    const lng = place.geometry?.location?.lng() ?? 0;
    return {
      name,
      cityName,
      countryName,
      countryCode,
      stateCode,
      bounds: place?.geometry?.viewport?.toJSON() ?? {
        north: 0, south: 0, east: 0, west: 0
      },
      coordinates: {
        lat: lat,
        lng: lng,
      },
    };
  }

  getLong(components: Components, name: string): string | null {
    const comp = this.getComponent(components, name);
    return comp ? comp.long_name : null;
  }

  getShort(components: Components, name: string): string | null {
    const comp = this.getComponent(components, name);
    return comp ? comp.short_name : null;
  }

  getComponent(components: Components, name: string) {
    if (!components) return null;
    return components.find((c: any) => c.types.includes(name)) || null;
  }

  pin(color: any) {
    return {
      path: "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0",
      fillColor: color,
      fillOpacity: 1,
      strokeColor: "#000",
      strokeWeight: 2,
      scale: 1,
    };
  }

  convertToDate(timeString: string): Date | null {
    if (!timeString) return null;
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, seconds || 0, 0);
    return date;
  }


  public handleBlurEmail(event: any) {
    const matchEmailValue = event.target.value?.trim();  // Get typed or pasted value
    const emailControl = this.addClientDirectoryFrom.get('Email');
    if (!matchEmailValue) {
      emailControl?.setErrors(null);
      this.emailerror = false; // no value, no error
      return;
    }
    if (this.originalEmail && matchEmailValue.toLowerCase() === this.originalEmail.toLowerCase()) {
      emailControl?.setErrors(null);
      this.emailerror = false;
      return;
    }

    this.clientDirectoryService.matchEmailName(matchEmailValue).subscribe((res: any) => {
      if (res.ResponseCode === 404) {
        this.emailerror = true;
        emailControl?.setErrors({ emailExists: true });
      } else {
        this.emailerror = false;
        const existingErrors = emailControl?.errors;
        if (existingErrors) {
          delete existingErrors['emailExists'];
          if (Object.keys(existingErrors).length === 0) {
            emailControl?.setErrors(null);
          } else {
            emailControl?.setErrors(existingErrors);
          }
        }
      }
    });
  }

  mobileNumberValidator(control: AbstractControl) {
    const value = control.value ? control.value.trim() : '';
    if (!value) {
      return { required: true }; // empty or spaces
    }
    if (!/^\d+$/.test(value)) {
      return { pattern: true }; // not digits
    }
    if (value.length < 10) {
      return { minlength: true };
    }
    if (value.length > 15) {
      return { maxlength: true };
    }
    return null;
  }

  //Domain Convert Start
  LoadDomainInit() {
    if (this.domain.includes("plus-doctor.com")) {
      this.plusDoctor = true;
    } else {
      this.plusDoctor = false;
    }
    if (window.location.host.includes("plus-doctor.com")) {
      this.domainName = ".plus-doctor.com"
    } else if (window.location.host.includes("ifour-consultancy.net")) {
      this.domainName = ".ifour-consultancy.net"
    }
    else if (window.location.host.includes("ifourtechlab.com")) {
      this.domainName = ".ifourtechlab.com"
    }
    else {
      this.domainName = ".plusphysio.com"
    }
    this.createForm();
    this.getCountry();
  }

  createForm() {
    this.domainForm = this.formBuilder.group({
      FirstName: [
        "",
        Validators.compose([
          Validators.required,
          this.noOnlySpacesValidator,
          Validators.maxLength(100),
          nameValidator
        ]),
      ],
      CompanyName: [
        "",
        Validators.compose([
          Validators.required,
          this.noOnlySpacesValidator,
          Validators.maxLength(250),
        ]),
      ],
      CompanyCode: [
        "",
        Validators.compose([
          Validators.required,
          this.noOnlySpacesValidator,
          Validators.maxLength(100),
        ]),
      ],
      Email: [
        "",
        Validators.compose([
          Validators.required,
          this.noOnlySpacesValidator,
          Validators.pattern("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$"),
        ]),
      ],
      Password: [
        "",
        Validators.compose([
          Validators.required,
          this.noOnlySpacesValidator,
          Validators.minLength(6),
        ]),
      ],
      PhoneNumber: ["", Validators.compose([Validators.required, this.noOnlySpacesValidator, this.validatePhoneNumber])],
      CompanyAddress: [
        "",
        Validators.compose([Validators.required, this.noOnlySpacesValidator, Validators.maxLength(300)]),
      ],
      CurrencyId: ["", [Validators.required]],
      Salutation: ["Dr."],
    });
  }

  noOnlySpacesValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.trim().length === 0) {
      return { required: true }; // mimic Angular's required error
    }
    return null;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.domainForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result =
      control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  get f() {
    return this.domainForm.controls;
  }
  validateForm() {
    for (let i in this.domainForm.controls) this.domainForm.controls[i].markAsTouched();
  }

  public handleBlurName() {
    let matchNameValue = this.f['CompanyName'].value;
    this.clientDirectoryService.matchClinicName(matchNameValue, this.selectedDoctor.Id).subscribe((res: any) => {
      if (res.ResponseCode === 447) {
        this.error = true;
        this.companycodeerror = false;
        this.f['CompanyCode'].setValue("");
      } else {
        this.error = false;
        if (!this.domainForm.controls['CompanyName'].invalid) {
          let name = this.f['CompanyName'].value.replace(/\s/g, "").toLowerCase();
          this.f['CompanyCode'].setValue(name);
          this.clientDirectoryService.matchDomain(name).subscribe((res: any) => {
            if (res.ResponseCode === 443) {
              this.companycodeerror = true;
            } else {
              this.companycodeerror = false;
            }
          });
        } else {
          this.f['CompanyCode'].setValue("");
        }
      }
    });
  }

  public handleBlurEmailbyId(event: any, id: number) {
    const matchEmailValue = event.target.value?.trim();  // Get typed or pasted value

    if (!matchEmailValue) {
      this.emailerror = false; // no value, no error
      return;
    }
    if (this.originalEmail && matchEmailValue.toLowerCase() === this.originalEmail.toLowerCase()) {
      this.emailerror = false;
      return;
    }

    this.clientDirectoryService.matchEmailNameById(matchEmailValue, id).subscribe((res: any) => {
      if (res.ResponseCode === 404) {
        this.emailerror = true;
      } else {
        this.emailerror = false;
      }
    });
  }


  public handleBlurCompanyCode() {
    let matchNameValue = this.f['CompanyCode'].value;
    this.clientDirectoryService.matchDomain(matchNameValue).subscribe((res: any) => {
      if (res.ResponseCode === 443) {
        this.companycodeerror = true;
      } else {
        this.companycodeerror = false;
      }
    });
  }

  validatePhoneNumber(control: AbstractControl): ValidationErrors | null {
    const regex = /^\d{10,15}$/;
    return control.value && !regex.test(control.value)
      ? { invalidPhone: true }
      : null;
  }

  onPhoneNumberKeyup() {
    const control = this.domainForm.controls['PhoneNumber'];
    const value = control.value;

    const errors: any = {};
    if (!value) {
      errors.required = true;
    }
    const phoneRegex = /^\d{10,15}$/;
    if (value && !phoneRegex.test(value)) {
      errors.invalidPhone = true;
    }

    control.setErrors(Object.keys(errors).length ? errors : null);
  }
  openDomainConvertDialog(dataItem: any): void {
    this.domainForm.reset();
    this.selectedDoctor = dataItem;
    this.domainForm.patchValue({
      FirstName: dataItem.Name ?? "",
      Salutation: dataItem.Salutation ?? "",
      CompanyName: dataItem.ClinicName ?? "",
      Email: dataItem.Email ?? "",
      Password: "111111",
      PhoneNumber: dataItem.MobileNumber ?? "",
      CompanyAddress: dataItem.Address ?? "",
      CurrencyId: dataItem.CurrencyId ?? 1,
    });

    this.stateName = dataItem.State ?? "";
    this.cityName = dataItem.City ?? "";
    this.handleBlurName();
    this.handleBlurCompanyCode();

    const dialogRef = this.dialog.open(this.domainConvertDialog, {
      autoFocus: false,
      width: '90vw',    // almost full width on mobile
      maxWidth: '700px', // but limit on desktop
      maxHeight: '90vh', // prevent overflow
      disableClose: true
    })

    dialogRef?.afterOpened().subscribe(() => {
      this.mapService.load().then((maps) => {
        this.initDomainAutocomplete(maps);
      });
    });
  }

  getCountry() {
    this.clientDirectoryService.getCountry().subscribe((res) => {
      if (res.Success) {
        this.currencyList = res['Data'];
      }
    })
  }

  convertDomain() {
    if (!this.domainForm.valid) {
      return;
    }

    let payload = {
      FirstName: this.f['FirstName'].value,
      Salutation: this.f['Salutation'].value,
      PhoneNumber: this.f['PhoneNumber'].value,
      Email: this.f['Email'].value,
      CompanyCode: this.f['CompanyCode'].value,
      CompanyName: this.f['CompanyName'].value,
      CompanyAddress: this.f['CompanyAddress'].value,
      Password: this.f['Password'].value,
      CurrencyId: this.f['CurrencyId'].value,
      Id: this.selectedDoctor.Id,
      City: this.cityName,
      State: this.stateName,
      IPAddress: this.ipAddress,
      IPLocation: this.ipLocation
    };

    this.loading = true;
    this.loaderService.show();
    this.clientDirectoryService.convertDirectorytoDomain(payload).subscribe({
      next: (res: any) => {
        if (res["Success"]) {
          this.toaster.success('Doctor Directory Converted to Domain Successfully');
          this.loadClientDirectoryData();
          this.closeDialog();
          this.loaderService.hide();
        } else {
          this.toaster.error(res["Message"] ?? 'Something went wrong Record not Updated sorry');
          this.loaderService.hide();
        }
        this.loading = false;
      },
      error: (_err) => {
        this.toaster.error('Something went wrong Record not Updated sorry');
        this.loaderService.hide();
        this.loading = false;
      }
    });
  }

  // ===== Specialization Dropdown =====
  isDropdownOpen_specialization = false;
  buttonHasFocus_specialization = false;
  labelActive_specialization = false;
  @ViewChild('wrapper_special', { read: ElementRef }) wrapper_special!: ElementRef<HTMLElement>;

  // ===== Services Dropdown =====
  isDropdownOpen_service = false;
  buttonHasFocus_service = false;
  labelActive_service = false;
  @ViewChild('wrapper_service', { read: ElementRef }) wrapper_service!: ElementRef<HTMLElement>;

  // ---------- Specialization ----------
  toggleDropdown_special(event?: Event) {
    if (event) event.stopPropagation();
    this.isDropdownOpen_specialization = !this.isDropdownOpen_specialization;
    this.updateLabelState_special();
  }

  onButtonFocus_special() {
    this.buttonHasFocus_specialization = true;
    this.updateLabelState_special();
  }

  onButtonBlur_special() {
    this.buttonHasFocus_specialization = false;
    this.updateLabelState_special();
  }

  updateLabelState_special() {
    this.labelActive_specialization = !!(
      (this.selectedSpecialization?.length) ||
      this.isDropdownOpen_specialization ||
      this.buttonHasFocus_specialization
    );
  }

  // ---------- Services ----------
  toggleDropdown_service(event?: Event) {
    if (event) event.stopPropagation();
    this.isDropdownOpen_service = !this.isDropdownOpen_service;
    this.updateLabelState_service();
  }

  onButtonFocus_service() {
    this.buttonHasFocus_service = true;
    this.updateLabelState_service();
  }

  onButtonBlur_service() {
    this.buttonHasFocus_service = false;
    this.updateLabelState_service();
  }

  updateLabelState_service() {
    this.labelActive_service = !!(
      (this.selectedServices?.length) ||
      this.isDropdownOpen_service ||
      this.buttonHasFocus_service
    );
  }

  // ---------- Single Document Click Handler ----------
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as Node;

    // --- specialization dropdown close check ---
    const clickedInsideSpecial = this.wrapper_special?.nativeElement?.contains(target);
    if (!clickedInsideSpecial) {
      this.isDropdownOpen_specialization = false;
      this.updateLabelState_special();
    }

    // --- services dropdown close check ---
    const clickedInsideService = this.wrapper_service?.nativeElement?.contains(target);
    if (!clickedInsideService) {
      this.isDropdownOpen_service = false;
      this.updateLabelState_service();
    }
  }

  toggleMaximize(): void {
    const overlayPane = document.querySelector('.cdk-overlay-pane:has(mat-dialog-container)');
    if (!(overlayPane instanceof HTMLElement)) return;
    const dialogElement = document.querySelector('mat-dialog-container');
    if (!(dialogElement instanceof HTMLElement)) return;
    const contentElement = dialogElement?.querySelector('.mat-dialog-content');
    if (!(contentElement instanceof HTMLElement)) return;
    this.mapService.maximizeMinimize();
    if (!overlayPane || !dialogElement) return;
    this.isMaximized = !this.isMaximized;
    if (this.isMaximized) {
      // Save original styles only once
      if (!this.originalOverlayStyle.width) {
        this.originalOverlayStyle = {
          position: overlayPane.style.position,
          top: overlayPane.style.top,
          left: overlayPane.style.left,
          margin: overlayPane.style.margin,
          width: overlayPane.style.width,
          height: overlayPane.style.height,
          maxWidth: overlayPane.style.maxWidth,
          maxHeight: overlayPane.style.maxHeight
        };

        this.originalDialogStyle = {
          width: dialogElement.style.width,
          height: dialogElement.style.height,
          maxHeight: dialogElement.style.maxHeight
        };
      }

      // Apply maximize styles
      overlayPane.style.position = 'fixed';
      overlayPane.style.top = '0';
      overlayPane.style.left = '0';
      overlayPane.style.margin = '0';
      overlayPane.style.setProperty('width', '100vw', 'important');
      overlayPane.style.setProperty('height', '100vh', 'important');
      overlayPane.style.setProperty('max-width', '100vw', 'important');
      overlayPane.style.setProperty('max-height', '100vh', 'important');

      dialogElement.style.setProperty('width', '100vw', 'important');
      dialogElement.style.setProperty('max-width', '100vw', 'important');
      contentElement.style.maxHeight = '72vh';
    } else {
      // Restore original styles
      overlayPane.style.position = this.originalOverlayStyle.position ?? '';
      overlayPane.style.top = this.originalOverlayStyle.top ?? '';
      overlayPane.style.left = this.originalOverlayStyle.left ?? '';
      overlayPane.style.margin = this.originalOverlayStyle.margin ?? '';
      overlayPane.style.width = this.originalOverlayStyle.width ?? '';
      overlayPane.style.height = this.originalOverlayStyle.height ?? '';
      overlayPane.style.maxWidth = this.originalOverlayStyle.maxWidth ?? '';
      overlayPane.style.maxHeight = this.originalOverlayStyle.maxHeight ?? '';

      dialogElement.style.width = this.originalDialogStyle.width ?? '';
      dialogElement.style.height = this.originalDialogStyle.height ?? '';
      contentElement.style.maxHeight = this.originalDialogStyle.maxHeight ?? '';
    }
  }

  onColumnVisibilityChange(columnEvent: GridComponent): void {
    this.gridSettings.saveGridSettings(columnEvent, this.TableName).subscribe();
  }

  ngAfterViewInit(): void {
    this.gridSettings.applyGridSettings(this._http, this.TableName, this.gridKendo);
  }
}
